import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';
import { errorHandler } from 'App/utils';

function useFetchPatientTherapies(patientId) {
    return useQuery(
        ['patient', patientId, 'therapies'],
        () => (!patientId ? null : PESService.getTherapies(patientId)),
        {
            onError: errorHandler,
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000,
        }
    );
}

export default useFetchPatientTherapies;
